import { ActionType } from "react-table";
import { ActionsCell } from "../../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../../Component/Common/Components/DataTable/DefaultCell";
import { TableColumn } from "../../../../../../Component/Model/Table/Table";
import { CurrencyFormatter } from "../../../../../../Helpers/CurrencyFormatter";
import { MerSetaSDITrainerSearchResult } from "../../../../../../Component/Model/Dto/WSP/MerSETASDI";
import { useRecoilValue } from "recoil";
import { userRolesState } from "../../../../../../State/user.Atom";
import { PlatformPeopleSalaryEditRole, PlatformPeopleSalaryViewRole, UserAdminRole } from "../../../../../../Component/Common/Constants/UserRoles";


interface MerSetaSDITrainerRows {
    id: number;
    trainer: string;
    jobTitle: string;
    duration: number;
    cost: string | number;
    actions: ActionType[];
}

interface MerSetaSDITable {
    columns: Array<TableColumn>;
    rows: Array<MerSetaSDITrainerRows>;
}

export function MerSetaSDITableMapper(dataObject: MerSetaSDITrainerSearchResult[], handleEdit: (platformPeopleId: string, fullName: string) => void, handleDelete: (index: number, fullName: string) => void): MerSetaSDITable {
    const userRoles = useRecoilValue(userRolesState);

    const viewRoleAccess = [
        PlatformPeopleSalaryViewRole,
        PlatformPeopleSalaryEditRole,
        UserAdminRole
    ]

    const editRoleAccess = [
        PlatformPeopleSalaryEditRole,
        UserAdminRole
    ]

    const canView = userRoles.some(r => viewRoleAccess.includes(r));
    const canEdit = userRoles.some(r => editRoleAccess.includes(r));
    const columns = [
        { Header: 'Trainer', accessor: 'trainer', id: 'trainer', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Job Title', accessor: 'jobTitle', id: 'jobTitle', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Duration of Training (Hours)', accessor: 'duration', id: 'duration', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Cost', accessor: 'cost', id: 'cost', Cell: ({ value }: any) => <DefaultCell value={value} restrictionValue={!canView}/>, rightAlign: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: MerSetaSDITrainerSearchResult, index: number) => ({
            id: item.trainerId,
            trainer: item.trainer,
            jobTitle: item.jobTitle,
            duration: item.duration,
            cost: canView ? CurrencyFormatter(Number(item.cost)) : item.cost,
            actions: [
                canEdit && {
                    type: 'Edit',
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        handleEdit(item.platformPeopleId, item.trainer);
                    },
                    icon: {
                        color: 'info',
                        name: 'edit',
                    }
                },
                canEdit && {
                    type: 'Delete',
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        handleDelete(item.trainerId, item.trainer);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ].filter(Boolean) as ActionType[]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
